import React, { useState, useContext, memo } from "react";
import { ConfirmationModal } from "../../general/misc/ConfirmationModal";
import { ColorButton } from "../../general/misc/ColorButton";
import { Sliders } from "./Sliders";
import { AddOutfitContext } from "../../../contexts/Outfits/AddOutfit";
import { ZMenu } from "./ZMenu";

export const SizingMenu = memo(
	({ dispatch = () => null, setClearPieceModal = null }) => {
		return (
			<div className="flex w-full items-center flex-col">
				<Sliders />
				<ZMenu />
				<div className="flex flex-row flex-wrap gap-4 items-center w-2/3 lg:w-full bg-white mt-4 self-center">
					<ColorButton
						onClick={() =>
							dispatch({
								type: "reset_size",
							})
						}
						className="w-full text-sm lg:text-xs flex-grow basis-32"
						label="Reset Size"
					/>
					<ColorButton
						onClick={() =>
							dispatch({
								type: "reset_spacing",
							})
						}
						className="w-full text-sm lg:text-xs flex-grow basis-32"
						label="Reset Spacing"
					/>
					<ColorButton
						onClick={() =>
							dispatch({
								type: "reset_cords",
							})
						}
						className="w-full text-sm lg:text-xs flex-grow basis-32"
						label="Reset Top/Left"
					/>
					<ColorButton
						onClick={
							setClearPieceModal
								? () => setClearPieceModal(true)
								: () => dispatch({ type: "clear_piece" })
						}
						className="w-full text-sm lg:text-xs flex-grow basis-32"
						type="red"
						label="Clear Piece"
					/>
				</div>
			</div>
		);
	}
);

export const SizingMenuWrapper = memo(({ setClearPieceModal = null }) => {
	const [state, dispatch] = useContext(AddOutfitContext);
	return (
		<SizingMenu
			setClearPieceModal={setClearPieceModal}
			dispatch={dispatch}
		/>
	);
});
